// extracted by mini-css-extract-plugin
export default {"container":"styles_container__30xNT","deleteIcon":"styles_deleteIcon__kkZGU"};